export class PatientSearch {
  public InAutoGestion: boolean;
  public ViewResultWeb?: boolean;
  public FirstName: string;
  public LastName: string;
  public Id: number;
  public BirthDate?: number;
  public BirthYear?: number;
  public BirthMonth?: number;
   public getLastFirstName(): string {
    return this.LastName + ', ' + this.FirstName;
  }
}
